import React from 'react';

/**
 * Shared page hero used on internal pages (Financing, Investors, Sell, etc.).
 * Differs from the homepage hero, which is one-off.
 *
 * Renders an eyebrow, headline (with optional italic green emphasis word),
 * a lede paragraph, and an optional CTA row (children).
 */
export default function PageHero({ eyebrow, title, emphasis, lede, children }) {
  return (
    <section className="oc-section oc-section--white" style={{ paddingTop: 96, paddingBottom: 80 }}>
      <div className="oc-shell">
        <div className="oc-max-820">
          <div className="oc-eyebrow oc-mb-3 oc-rise oc-rise-1">{eyebrow}</div>
          <h1 className="oc-h1 oc-rise oc-rise-2">
            {title}{' '}
            {emphasis && <em className="oc-em">{emphasis}</em>}
          </h1>
          {lede && (
            <p className="oc-lede oc-mt-3 oc-mb-4 oc-rise oc-rise-3" style={{ fontSize: 17 }}>
              {lede}
            </p>
          )}
          {children && <div className="oc-row oc-rise oc-rise-3" style={{ gap: 8 }}>{children}</div>}
        </div>
      </div>
    </section>
  );
}
